import React, { useState, useEffect, useCallback } from "react";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../utility/Utility";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";

export default function FeedbackList() {

  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const rowsPerPage = 10;

  const fetchFeedbacks = useCallback(async () => {
    setLoading(true);
    try {
      const response = await postData("api/agent-leads/all-list", {
        search: searchTerm,
        page: currentPage + 1,
        limit: rowsPerPage,
        startDate: startDate,
        endDate: endDate
      });
      if (response.success) {
        setFeedbacks(response.data);
        setTotalPages(response.totalPages || 1);
      } else {
        toast.error(response.message || "Failed to fetch feedbacks");
      }
    } catch (error) {
      toast.error("Error fetching feedbacks");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, currentPage, startDate, endDate,rowsPerPage]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    fetchFeedbacks();
  };

  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(0);
    setSearchTerm(searchTerm);
    setStartDate(startDate);
    setEndDate(endDate);
    fetchFeedbacks();
  };

  const handleReset = (e) => {
    e.preventDefault();
    setSearchTerm("");
    setCurrentPage(0);
    setStartDate("");
    setEndDate("");
    fetchFeedbacks();
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Feedback Management</h4>
              <p className="fw-semibold my-2">Feedback List</p>
            </div>
            <div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-center">
                      <div className="col-md-12 col-lg-3">
                      <label htmlFor="searchTerm" className="form-label">Search</label>
                          <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search by agent..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />

                      </div>
                      <div className="col-md-12 col-lg-2 ">
                        <label htmlFor="startDate" className="form-label me-2">From Date</label>
                        <input
                          type="date"
                          className="form-control"
                          id="startDate"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>

                      <div className="col-md-12 col-lg-2 ">
                        <label htmlFor="endDate" className="form-label me-2">To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          id="endDate"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          min={startDate}
                        />
                      </div>
                      <div className="col-md-12 col-lg-3 d-flex gap-2 mt-4 pt-3">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Searching..." : "Search"}
                        </button>

                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleReset}
                          disabled={loading}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          {/* <th>User Name</th>
                          <th>User Mobile</th> */}
                          <th>Company Name</th>
                          <th>Insurance Type</th>
                          <th>Plan</th>
                          <th>Agent Name</th>
                          <th>Rating</th>
                          {/* <th>Comments</th> */}
                          <th>Feedback</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="8" className="text-center py-5">
                              Loading feedback...
                            </td>
                          </tr>
                        ) : feedbacks.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center py-4">
                              No feedback found
                            </td>
                          </tr>
                        ) : (
                          feedbacks.map((fb, index) => (
                            <tr key={fb._id}>
                              <td>{currentPage * rowsPerPage + index + 1}</td>
                              {/* <td>{fb.userId?.fullName || '-'}</td>
                              <td>{fb.userId?.mobile || '-'}</td> */}
                              <td>{fb.partnerId?.name }</td>
                              <td>{fb.insuranceType || '-'}</td>
                              <td>{fb.plan || '-'}</td>
                              <td>{fb.agentId?.fullName || '-'}</td>
                              <td>{fb.agentGivenRatingUser}</td>
                              {/* <td>{fb.comments}</td> */}
                              <td>{fb.agentFeedback}</td>
                              <td>{new Date(fb.createdAt).toLocaleString()}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                    {totalPages > 1 && (
                      <ReactPaginate
                        previousLabel={<i className="mdi mdi-chevron-left"></i>}
                        nextLabel={<i className="mdi mdi-chevron-right"></i>}
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={totalPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName="pagination pagination-rounded justify-content-end mt-3"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                        forcePage={currentPage}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
